/*
 * Petite Lune - personalización cobrada como línea aparte (opción A, 14/10).
 * Los Memory Journal armados como paquete (Shopify Bundles: cover + elástico) no reciben el
 * recargo de Live Product Options, así que los S/ 11 se agregan como el producto
 * «Personalización del nombre». Productos y precio: Ajustes del tema → Personalización Petite Lune.
 *  - Ficha: si se elige «SI PERSONALIZAR», agrega la línea (y los charms elegidos) antes del journal.
 *    El journal lleva la propiedad oculta _pl_key y la línea, _pl_for con el mismo valor.
 *    La línea también lleva «Nombre a grabar» y «Tipo de letra» para verlos sin abrir el paquete.
 *  - Carrito: la línea copia la cantidad de su journal y se quita sola si el journal se quita.
 */
(function () {
  if (window.plPzLinea) return;
  window.plPzLinea = true;
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var JSONH = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var origFetch = window.fetch.bind(window);

  /* ---------- Carrito: sincronizar la línea con su journal ---------- */
  var syncing = false, t;
  function sync() {
    if (syncing) return;
    syncing = true;
    origFetch(R + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var qty = {}, upd = {}, n = 0;
        cart.items.forEach(function (i) {
          var k = i.properties && i.properties._pl_key;
          if (k) qty[k] = (qty[k] || 0) + i.quantity;
        });
        cart.items.forEach(function (i) {
          var f = i.properties && i.properties._pl_for;
          if (!f) return;
          var want = qty[f] || 0;
          if (i.quantity !== want) { upd[i.key] = want; n++; }
        });
        if (!n) { syncing = false; return; }
        return origFetch(R + 'cart/update.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ updates: upd }) })
          .then(function () { location.reload(); });
      })
      .catch(function () { syncing = false; });
  }
  function later() { clearTimeout(t); t = setTimeout(sync, 700); }
  window.fetch = function (input) {
    var u = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(window, arguments);
    if (/\/cart\/(change|update|add)/.test(u)) p.then(later, later);
    return p;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();

  /* ---------- Ficha: agregar la línea al carrito ---------- */
  var L = (window.plPz || {}).line;
  if (!L) return;

  function personalized() {
    var r = document.querySelector('.cl-po--option[data-option=Personalizar]');
    if (r) return !!r.querySelector('input:checked[value^=SI]');
    return [].some.call(document.querySelectorAll('.cl-po--option input[type=text], .cl-po--option textarea'), function (i) {
      return i.value.trim() !== '';
    });
  }
  // Copy the engraving name and font to the S/ 11 line: Bundles keeps them only inside the
  // collapsed «Parte de» block of the order, and the line is what the admin and emails show.
  function lineProps(key) {
    var p = { Para: L.title }, name = [], font = '';
    [].forEach.call(document.querySelectorAll('.cl-po--option'), function (o) {
      if (!o.getClientRects().length) return;
      if (/letra/i.test(o.dataset.option || '')) {
        var s = o.querySelector('select, input:checked');
        if (s && s.value) font = s.value;
        return;
      }
      [].forEach.call(o.querySelectorAll('input[type=text], textarea'), function (i) {
        if (i.value.trim()) name.push(i.value.trim());
      });
    });
    if (name.length) p['Nombre a grabar'] = name.join(' / ');
    if (font) p['Tipo de letra'] = font;
    p._pl_for = key;
    return p;
  }
  function charms() { return typeof window.plCharmItems === 'function' ? window.plCharmItems() : []; }

  var busy = 0, passUntil = 0;
  function needed() { return personalized() || charms().length > 0; }

  function go(f, b) {
    if (busy) return;
    // Validate before adding paid extras, including LPO's policy checkbox.
    var consent = document.querySelector('.cl-po--option[data-option="Politica de personalizacion"] input[type=checkbox]');
    if (consent) consent.required = personalized() && consent.getClientRects().length > 0;
    if (!f.reportValidity()) return;
    busy = 1;
    if (b) b.disabled = true;
    var items = charms();
    var old = f.querySelector('input[name="properties[_pl_key]"]');
    if (old) old.remove();
    if (personalized()) {
      var key = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      var h = document.createElement('input');
      h.type = 'hidden'; h.name = 'properties[_pl_key]'; h.value = key;
      f.appendChild(h);
      var q = f.querySelector('[name=quantity]') || document.querySelector('input[name=quantity][form="' + f.id + '"]');
      items.push({ id: L.vid, quantity: Math.max(1, +(q && q.value) || 1), properties: lineProps(key) });
    }
    origFetch(R + 'cart/add.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ items: items }) })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw j;
          busy = 0;
          if (b) b.disabled = false;
          passUntil = Date.now() + 8000;
          if (b) b.click();
          else if (f.requestSubmit) f.requestSubmit();
          else f.submit();
        });
      })
      .catch(function (j) {
        busy = 0;
        if (b) b.disabled = false;
        alert((j && (j.description || j.message)) || 'No se pudo agregar al carrito');
      });
  }
  function passing() { return Date.now() < passUntil; }
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[name="add"], .add-to-cart-button');
    if (!b || !e.isTrusted) return;
    var f = b.form || b.closest('form');
    if (!f || !/cart\/add/.test(f.action)) return;
    if (!needed()) {
      var old = f.querySelector('input[name="properties[_pl_key]"]');
      if (old) old.remove();
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    passUntil = 0;
    go(f, b);
  }, true);
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (passing() || !/cart\/add/.test(f.action || '') || !needed()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    go(f);
  }, true);
})();
